import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Injectable()
export class LocationService {
  constructor(private firebaseFunctions: Functions) {}

  async archiveLocation(params: { locId: string }) {
    const archive = httpsCallable(this.firebaseFunctions, 'archiveLocation');
    return (await archive(params)).data;
  }
}
